import { z } from "zod";
import { serviceInvoiceStatus } from "./get-current-marketing-email-invoice";

export const getCurrentMarketingSmsInvoice = {
  input: z.null(),
  output: serviceInvoiceStatus.nullable(),
};
